import * as React from 'react';

import { createTheme, UnifiThemeProvider } from '@nelnet/unifi-components-react';

import customPaletteThemeOptions from './customPaletteThemeOptions';
import customTypographyThemeOptions from './customTypographyThemeOptions';
import TaskTheme from '../task/TaskTheme';

interface IDemoThemesProps {
  theme?: string;
}

const DemoThemes: React.FunctionComponent<IDemoThemesProps> = ({ children, theme }) => {
  if (theme === 'palette') {
    const customPaletteTheme = createTheme(customPaletteThemeOptions);
    return <UnifiThemeProvider theme={customPaletteTheme}>{children}</UnifiThemeProvider>;
  }

  if (theme === 'typography') {
    const customTypographyTheme = createTheme(customTypographyThemeOptions);
    return <UnifiThemeProvider theme={customTypographyTheme}>{children}</UnifiThemeProvider>;
  }

  if (theme === 'task') {
    return <TaskTheme>{children}</TaskTheme>;
  }

  return null;
};

export default DemoThemes;
